import {
  DOCUMENTATION_SET,
  DOCUMENTATION_COUNT_SET,
  DOCUMENTATION_RESET,
  DIRECTORY_SET,
} from 'components/admin/projects/details/project-documentation/store/action-types';

const initialState = {
  documentation: {},
  documentationCount: null,
};

export default function projectDocumentationDataReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case DOCUMENTATION_SET:
      return {
        ...state,
        documentation: {
          ...state.documentation,
          [action.payload.category]: action.payload.documentation,
        },
      };

    case DOCUMENTATION_COUNT_SET:
      return {
        ...state,
        documentationCount: action.payload,
      };

    case DOCUMENTATION_RESET:
      return initialState;

    case DIRECTORY_SET:
      return {
        ...state,
        directory: action.payload,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/projects/details/project-documentation/store/reducers.data.js